import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import { FlowProvider } from '_/contexts/FlowContext';
import { useProject } from '_/contexts/ProjectContext';
import { useCollections } from '_/hooks/useCollections';
import { useFlowList } from '_/hooks/useFlows';
import React, { ReactElement } from 'react';

import NewProjectFlow from '../NewProjectFlow';

function NewFlowContainer(): ReactElement {
  const { selectedProject: project } = useProject();
  const { data: collections = [], isLoading: isCollectionsLoading } = useCollections(project?.id);
  const { data: flows = [], isLoading: isFlowsLoading } = useFlowList(project?.id);

  const isLoading = !project?.id || isCollectionsLoading || isFlowsLoading;

  return (
    <AsyncPageContainer isLoading={isLoading}>
      <FlowProvider>
        <NewProjectFlow collections={collections} flows={flows} />
      </FlowProvider>
    </AsyncPageContainer>
  );
}

export default NewFlowContainer;
